export default __webpack_public_path__ + "static/media/mint_nfts.fd3cff56.png";